export default __webpack_public_path__ + "static/logoFooter-8cebd6e90982f0ca627181459f82ced8.svg";